<template>
  <div>
    <loading-panel :visible="loading"></loading-panel>
    <div class="header pb-8 pt-4 pt-lg-5 d-flex profile-header"
        style="min-height: 100vh; background-image: url(img/theme/header-background.png); background-size: cover; background-position: center top;">
      <b-container fluid class="mt-6">
        <b-row >
          <b-col cols="8">
            <h4 class="display-4 text-dark">{{ $t('admin.meetup.pageTitle') }}</h4>
          </b-col>
          <b-col align="right">
          <el-tooltip placement="bottom" :content="$t('tooltip.add')">
            <b-link to="/admin/meetup/0">
                <i class="icon-sm"><b-img alt="..." src="./img/icons/common/add.svg" /></i>
            </b-link>
            </el-tooltip>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="12" class="card-meetup-admin">
            <b-row class="main-search-admin-div">
              <b-col cols="8" align="left">
                <vue-excel-xlsx
                    :data="allServiceLines"
                    :columns="columns"
                    :file-name="'service-line_' + new Date().toJSON().slice(0,19).replace(/-/g,'/')"
                    :file-type="'xlsx'"
                    :sheet-name="'service-lines'"
                    >
                    <el-tooltip placement="bottom" :content="$t('sl.export.excel')">
                      <img width="32" src="img/icons/common/excel-96.svg" alt="export - excel" />
                    </el-tooltip>   
                </vue-excel-xlsx>              
              </b-col>
              <b-col cols="4" align="right">
                <input class="search-input search-input-admin" v-model="search" :placeholder="$t('sl.search.title')" @input="searchServiceLines" v-on:keyup.enter="searchServiceLines"/> <i @click="searchServiceLines" class="el-icon-search search-admin"></i>
              </b-col>
            </b-row>
            <div class="el-table el-table-admin-sl table-responsive table el-table--fit el-table--enable-row-hover el-table--enable-row-transition">
              <b-row align-v="center" class="header">
                  <b-col  class="el-table-date-column">
                      {{ $t('admin.meetup.meetupDate') }}
                      <i :class="(columnToSort.columnName==='sli_startat')?((columnToSort.direction==='ASC')?'fa fa-sort-up':'fa fa-sort-down'):'fa fa-sort'" @click="sortColumn('sli_startat')" aria-hidden="true"></i>
                  </b-col>
                  <b-col class="el-table-title-column">
                      {{ $t('admin.meetup.meetupTitle') }}
                      <!-- <i :class="(columnToSort.columnName==='sll_title')?((columnToSort.direction==='ASC')?'fa fa-sort-up':'fa fa-sort-down'):'fa fa-sort'" @click="sortColumn('sll_title')" aria-hidden="true"></i> -->
                  </b-col>
                  <b-col class="el-table-speaker-column" >
                      {{ $t('admin.meetup.chairpersons') }}
                      <i :class="(columnToSort.columnName==='sli_speakers')?((columnToSort.direction==='ASC')?'fa fa-sort-up':'fa fa-sort-down'):'fa fa-sort'"  @click="sortColumn('sli_speakers')" aria-hidden="true"></i>
                  </b-col>
                  <b-col class="el-table-time-column" >
                      {{ $t('admin.meetup.meetupTime') }}
                  </b-col>
                  <b-col  class="el-table-access-column">
                      {{ $t('admin.meetup.meetupAccessLevel') }}
                      <i :class="(columnToSort.columnName==='sli_accesslevel')?((columnToSort.direction==='ASC')?'fa fa-sort-up':'fa fa-sort-down'):'fa fa-sort'" @click="sortColumn('sli_accesslevel')" aria-hidden="true"></i>
                  </b-col>
                  <b-col  class="el-table-type-column">
                      {{ $t('admin.meetup.meetupType') }}
                      <i :class="(columnToSort.columnName==='slt_id')?((columnToSort.direction==='ASC')?'fa fa-sort-up':'fa fa-sort-down'):'fa fa-sort'" @click="sortColumn('slt_id')" aria-hidden="true"></i>
                  </b-col>
                  <b-col  class="el-table-actions-column text-center"> 
                      {{ $t('admin.meetup.actions') }}                
                  </b-col>         
              </b-row>
             
              
                <b-row align-v="center" class="list-item el-table__row" v-for="(item, index) in serviceLines"
                :key="item.sli_id" 
                :index="index"
                >
                      <b-col class="ellipsis el-table-date-column">
                          <el-tooltip placement="bottom" :content="getDate(item.sli_startat)">
                            <span>{{ getDate(item.sli_startat) }}</span>
                          </el-tooltip>    
                      </b-col>
                      <b-col class="ellipsis el-table-title-column">
                          <el-tooltip placement="bottom" :content="item.servicelinelangs[0].sll_title">
                            <span>{{ item.servicelinelangs[0].sll_title }}</span>
                          </el-tooltip>    
                      </b-col>
                      <b-col  class="ellipsis el-table-speaker-column">
                          <el-tooltip placement="bottom" :content="item.sli_speakers">
                            <span>{{ item.sli_speakers }}</span>
                          </el-tooltip>    
                      </b-col>
                      <b-col  class="ellipsis el-table-time-column">
                          <el-tooltip placement="bottom" :content="getHour(item.sli_startat)+' - '+getHour(item.sli_endat)">
                            <span>{{ getHour(item.sli_startat) }} - {{ getHour(item.sli_endat) }}</span>
                          </el-tooltip>    
                      </b-col>
                      <b-col class="ellipsis el-table-access-column">
                          <el-tooltip placement="bottom" :content="$t('sl.optionsAccess.'+item.sli_accesslevel)">
                            <span>{{ $t('sl.optionsAccess.'+item.sli_accesslevel) }}</span>
                          </el-tooltip>    
                      </b-col>
                      <b-col class="ellipsis el-table-type-column">
                          <el-tooltip placement="bottom" :content="$t('sl.type.'+item.slt_id)">
                            <span>{{ $t('sl.type.'+item.slt_id)}}</span>
                          </el-tooltip>    
                      </b-col>
                      
                      <b-col class="text-center el-table-actions-column"> 
                          <b-row class="m-0 text-center">
                              <b-col cols="6"  class="p-0 el-table-admin-sl-icon">
                                <el-tooltip placement="bottom" :content="$t('tooltip.edit')">
                                  <a href="javascript:void(0)" class="icon action-edit" @click="editServiceLine(item.sli_id)">
                                      <i><img src="img/icons/common/edit.svg"/></i>
                                  </a>
                                </el-tooltip>
                              </b-col>
                              <b-col cols="6" class="p-0 el-table-admin-sl-icon">
                                <el-tooltip placement="bottom" :content="$t('tooltip.delete')">
                                  <a href="javascript:void(0)" class="icon action-delete" @click="confirmDeletion(item.sli_id)">
                                      <i><img src="img/icons/common/trash.svg"/></i>
                                  </a>
                                </el-tooltip>
                              </b-col>
                                           
                          </b-row>                
                      </b-col>         
                  </b-row>
            
            </div>
            <div class="pagination-admin-div">
              <pagination v-model="page" :per-page="perPage" :records="totalItems" @paginate="handlePageChange"/>
            </div>
          </b-col>
        </b-row>

        <div>
          <b-modal class="modal-confirm" size="sm" centered v-model="showConfirm" :title="$t('generic.warning-title')" button-size="sm" ok-only hide-footer hide-header>
            <h3 class="text-center text-danger">{{ $t('generic.warning-title') }}</h3> 

            <div class="d-block text-center">
              <p>{{ $t('generic.deletion-confirm') }}</p>
            </div>
            <b-button-group class="d-flex justify-content-center">
              <b-button style="max-width: 150px;" variant="primary" @click="deleteServiceLine">{{ $t('generic.btn-delete') }}</b-button>
              <b-button style="max-width: 150px;" variant="secondary" @click="showConfirm = false">{{ $t('generic.btn-cancel') }}</b-button>
            </b-button-group>   
          </b-modal>
        </div>         
      </b-container>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import { Table, TableColumn} from 'element-ui';
  import { mapActions } from "vuex";
  import Pagination from 'vue-pagination-2';
  import Sortable from 'vue-drag-sortable';
  import VueExcelXlsx from "vue-excel-xlsx";

  Vue.use(VueExcelXlsx);

  export default {
    name: 'meetups-page',    
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Sortable,
      Pagination
    },
    data() {
      this.loadServiceLines();
      this.loadAllServiceLines();

      return {      
        lang: Vue.i18n.locale(),
        serviceLines: [],
        allServiceLines: [],
        serviceLinesRequest: {
          search: '',
          lang: Vue.i18n.locale(),
          page:0
        },
        columnToSort:{
          columnName:'sli_startat',
          direction:'DESC'
        },
        columns : [
            {
                label: "Date",
                field: "sli_startat",
                dataFormat: value => {
                  let date = new Date(value);
                  let dt = (date.getDate() < 10?'0' + date.getDate():date.getDate()) + '/' + (date.getMonth()+1 < 10? '0' + (date.getMonth()+1):date.getMonth()+1) + '/' + date.getFullYear();
                  return dt;
                }
            },
            {
                label: "Titre (FR)",
                field: "servicelinelangs[0].sll_title"
            },
            {
                label: "Titre (EN)",
                field: "servicelinelangs[1].sll_title",
            },
            {
                label: "Description (FR)",
                field: "servicelinelangs[0].sll_description",
            },
            {
                label: "Description (EN)",
                field: "servicelinelangs[1].sll_description",
            },
            {
                label: "Animateurs",
                field: "sli_speakers",
            },
            {
                label: "Heure de debut",
                field: "sli_startat",
                dataFormat: value => {
                    return this.getHour(value);
                }
            },
            {
                label: "Heure de fin",
                field: "sli_endat",
                dataFormat: value => {
                    return this.getHour(value);
                }        
            },
            {
                label: "Accès",
                field: "sli_accesslevel",
                dataFormat: value => {
                    return this.$t('sl.optionsAccess.'+value);
                }        
            },
            {
                label: "Type",
                field: "slt_id",
                dataFormat: value => {
                    return this.$t('sl.type.'+value);
                }        
            },
            {
                label: "Teams",
                field: "sli_teamslink",
            },
            {
                label: "Lien stream",
                field: "sli_streamlink",
            }
        ],          
        loading: false,
        exportloading: false,
        file_name: '',
        search:'',
        page: 1,
        totalItems: 0,
        perPage: 10,
        showConfirm: false,
        itemToDelete: null  
      };
    },
    methods: {
        ...mapActions(["GetListServiceLinesAdmin", "DeleteServiceLine", "ExportServiceLinesAdmin"]),
        async loadAllServiceLines() {
            this.exportloading = true;
            this.serviceLinesRequest={
              search: ''
            }
            new Date().toJSON().slice(0,10).replace(/-/g,'/');
            this.file_name = "service-line_" + new Date().toJSON().slice(0,19).replace(/-/g,'/') + ".xlsx";
            await this.ExportServiceLinesAdmin(this.serviceLinesRequest)
            this.allServiceLines = this.$store.getters.ExportServiceLines;
        },
        hideloading() {
          this.exportloading = false;
        },
        async loadServiceLines() {
            this.serviceLinesRequest={
              search: '',
              lang: Vue.i18n.locale(),
              page:0,
            }
            await this.GetListServiceLinesAdmin(this.serviceLinesRequest)
            this.serviceLines = this.$store.getters.AllServiceLines.list; 
            this.totalItems=this.$store.getters.AllServiceLines.totalItems;
            this.perPage = this.$store.getters.AllServiceLines.pageSize;
        },
        editServiceLine(id) {
            this.$router.push({ path: `/admin/meetup/${id}` });
        },
        confirmDeletion(sli_id) {
          this.showConfirm = true;
          this.itemToDelete = sli_id;
        },
        async deleteServiceLine() {
          this.loading = true;
          /*this.serviceLines = this.$store.getters.AllServiceLines;
          let slToDelete = this.serviceLines[index];*/
          
          await this.DeleteServiceLine(this.itemToDelete);
          if(this.$store.getters.IsDeleted){
            this.searchServiceLines();
            this.loadAllServiceLines();
            this.showConfirm = false;
          }
          /*this.serviceLines = this.$store.getters.AllServiceLines.list;
          this.totalItems=this.$store.getters.AllServiceLines.totalItems;*/
          this.loading = false;
        },
        async searchServiceLines(){
           this.serviceLinesRequest={
              search: this.search,
              lang: Vue.i18n.locale(),
              page:0
            }
            await this.GetListServiceLinesAdmin(this.serviceLinesRequest)
            this.serviceLines = this.$store.getters.AllServiceLines.list; 
            this.totalItems=this.$store.getters.AllServiceLines.totalItems; 
            this.page=1;
        },
        async handlePageChange(value) {
          this.page = value;
          this.serviceLinesRequest={
            search: this.search,
            lang: this.lang,
            page:value-1,
            sort:this.$data.columnToSort.columnName,
            direction: this.$data.columnToSort.direction
          }
          await this.GetListServiceLinesAdmin(this.serviceLinesRequest)
          this.serviceLines = this.$store.getters.AllServiceLines.list; 
        },
        async sortColumn(columnName){
            let currentColumnSort={
              columnName:columnName,
              direction:'ASC'
            }
            if(this.$data.columnToSort.columnName===columnName){
              if(this.$data.columnToSort.direction==='ASC'){
                currentColumnSort.direction='DESC';
                this.$data.columnToSort.direction='DESC';

              }
              else{
                currentColumnSort.direction='ASC';
                this.$data.columnToSort.direction='ASC';
              }
            }
            else{
              this.$data.columnToSort=currentColumnSort;
            }
           this.serviceLinesRequest={
              search: this.search,
              lang: Vue.i18n.locale(),
              page:0,
              sort:columnName,
              direction:currentColumnSort.direction
            }
            await this.GetListServiceLinesAdmin(this.serviceLinesRequest)
            this.serviceLines = this.$store.getters.AllServiceLines.list; 
            this.totalItems=this.$store.getters.AllServiceLines.totalItems; 
            this.page=1;
        },
        getDate(stringDate){
            let response="";
            if(stringDate!="" && stringDate!=null && stringDate!=undefined ){
              const sYear=stringDate.toString().substring(0, 4);
              const sMonth=stringDate.toString().substring(5,7);
              const sDay=stringDate.toString().substring(8,10);
              response=sDay+"-"+sMonth+"-"+sYear;
            }
            return response;
        },
        getHour(stringDate){
            let response="";
            if(stringDate!="" && stringDate!=null && stringDate!=undefined ){
              response=stringDate.toString().substring(11,16);
            }
            return response;
        },
        onTranslate(){

        },
        async exchangeLang() {
            this.lang == 'fr'?this.lang = 'en':this.lang = 'fr';
            await this.GetListServiceLines(this.lang);
            this.serviceLines = this.$store.getters.AllServiceLines
        },
        click (e) {
        // Todo
        },
        sort (e) {
          const { oldIndex, newIndex } = e
        },
        sortend (e, list) {
          const { oldIndex, newIndex } = e
          this.rearrange(list, oldIndex, newIndex)
        },
        // async rearrange (array, oldIndex, newIndex) {
        //   this.loading = true;
        //   let body = {
        //       lan_code: Vue.i18n.locale(),
        //       car_id: array[oldIndex].car_id,
        //       car_order: newIndex + 1
        //   }
        //   await this.UpdateOrder(body);
        //   this.serviceLines = this.$store.getters.AllServiceLines;
        //   this.loading = false;
        // }
    }
  }
</script>
